import { useEvents } from "./useEvents";

export default useEvents;
